import { EDIT_PRIVACY_SETTINGS } from "shared/api";
import { CheckboxField, Form, Page, SelectField, SubmitButton } from "shared/react";
import { PRIVACY_FORM_SCHEMA } from "shared/schema";
import { callAPI } from "../util/api.js";
import { useItem } from "../util/db.js";
import { USER } from "../util/user.js";

export function PrivacySettingsPage(): React.ReactElement {
	const userItem = useItem("user", USER.data.uid);
	return (
		<Page title="Privacy settings">
			<header>
				<h1 className="smush">Privacy settings</h1>
				<p className="color-quiet size-small smush">Default visibility for new content you create.</p>
			</header>
			<Form schema={PRIVACY_FORM_SCHEMA} data={userItem.data} onSubmit={v => callAPI(EDIT_PRIVACY_SETTINGS, v)}>
				<SelectField name="postPrivacy" />
				<SelectField name="challengePrivacy" />
				{/* <SelectField name="attemptPrivacy" /> Hidden until we expose this on user's profiles. */}
				<SelectField name="earnedPrivacy" />
				<CheckboxField name="approval" />
				<SubmitButton>Save settings</SubmitButton>
			</Form>
		</Page>
	);
}
